import { Component, OnInit, ViewChild } from '@angular/core';
import { SettingsService } from '../../services/settings.service';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { FormControl } from '@angular/forms';
import { Observable, EMPTY, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-doctor',
  templateUrl: './doctor.component.html',
  styleUrls: ['./doctor.component.css']
})
export class SettingsDoctorComponent implements OnInit {

  public doctors: any[];
  usersFilter: any[];
  users: any[];
  userId: string;
  patientId: number = 0;
  residents: any = [];
  condition: boolean;
  showSuccessMessage: boolean;

  constructor(private settingsService: SettingsService,
    private router: Router,
    private sharedService: SharedService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.sharedService.facilityUnitId = 0;
    this.loadUsers();
    this.loadFilteredOptions();
  }

  public matrixData: any[] = [];
  public filteredMatrixData: any[] = [];
  public doctorColumns: any[] = [];
  public searchControl = new FormControl();
  public doctorFilterControl = new FormControl('');

  loadUsers() {
    this.settingsService.getDoctorResidents(this.sharedService.pharmacyId, this.sharedService.facilityId)
      .subscribe(data => {
        this.processMatrixData(data);
      });
      
    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => {
       this.filterMatrix();
    });

    this.doctorFilterControl.valueChanges.subscribe(() => {
      this.filterMatrix();
    });
  }

  processMatrixData(data: any[]) {
    // 1. Extract all unique doctors
    this.doctorColumns = data.map(u => ({ id: u.userId, name: u.userFullname }));

    // 2. Extract all unique residents (flatten the list)
    const allResidentsMap = new Map<number, any>();
    data.forEach(user => {
      user.residents.forEach(resident => {
        if (!allResidentsMap.has(resident.id)) {
          allResidentsMap.set(resident.id, { id: resident.id, name: resident.name, assignments: {} });
        }
        // Mark assignment
        allResidentsMap.get(resident.id).assignments[user.userId] = true;
      });
    });

    // 3. Convert map to array and sort by name
    this.matrixData = Array.from(allResidentsMap.values()).sort((a, b) => a.name.localeCompare(b.name));
    this.filteredMatrixData = this.matrixData;
  }
  
  filterMatrix() {
    let filtered = this.matrixData;
    
    // Filter by Resident Name
    const searchValue = this.searchControl.value;
    if (searchValue && searchValue.trim() !== '') {
       const lowerValue = searchValue.toLowerCase();
       filtered = filtered.filter(item => item.name.toLowerCase().includes(lowerValue));
    }

    // Filter by Doctor Assignment
    const selectedDoctorId = this.doctorFilterControl.value;
    if (selectedDoctorId && selectedDoctorId !== '') {
      filtered = filtered.filter(item => item.assignments[selectedDoctorId]);
    }

    this.filteredMatrixData = filtered;
  }

  openNew() {
    this.router.navigate(['/settings/doctors/edit']);
  }


  //Autocomplete Residents element

  myControl = new FormControl();
  filteredOptions: Observable<any>;
  toHighlight: string = '';

  loadFilteredOptions() {

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(100),
      distinctUntilChanged(),
      switchMap(val => {
        return this._filter(val || '')
      })
    )
  }

  private _filter(value: string): Observable<any[]> {
    this.getData();

    this.toHighlight = value;

    var data = this.getData();
    if (data != null)
      return this.getData()
        .pipe(
          map(response => response.filter(option => {
            return option.fullName.toLowerCase().indexOf(value.toLowerCase()) >= 0
          }))
        )
    else
      return EMPTY;

  }

  getPosts(value) {
    var user = this.usersFilter.find(f => f.fullName == value);
    //this.patientId = resident.patientId;
    //this.loadEprescribers();
    this.condition = false;
    this.showSuccessMessage = false;
  }

  getData() {
    if (this.usersFilter == null || this.usersFilter.length == 0) {
      this.settingsService.getUserDoctors(this.sharedService.pharmacyId, this.sharedService.facilityId).subscribe(data => {
        this.usersFilter = data;
        return of(this.usersFilter);
      });
    } else {
      return of(this.usersFilter);
    }
  }

}

//Highlight text in autocomplete options

import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  transform(text: string, search): string {
    if (search && text && typeof search === 'string' && typeof text === 'string') {
      const pattern = search
        .replace(/[\-\[\]\/{}()*x+?.\\^$|]/g, '\\$&')
        .split(' ')
        .filter(t => t.length > 0)
        .join('|');
      const regex = new RegExp(pattern, 'gi');
      return search ? text.replace(regex, match => `<strong class="highlight">${match}</strong>`) : text;
    }
    return text;
  }
}
